import React from "react";
import { Box, Badge, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

interface NavItem {
  icon: React.ReactNode;
  label: string;
  to: string;
  badge?: number;
}

interface MobileBottomNavProps {
  items: NavItem[];
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ items }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        bgcolor: "background.paper",
        borderTop: `1px solid ${theme.palette.divider}`,
        py: 1,
        display: { xs: "flex", md: "none" },
        justifyContent: "space-around",
      }}
    >
      {items.map((item) => (
        <Box
          key={item.label}
          component={Link}
          to={item.to}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
            px: 2,
            py: 1,
            borderRadius: 2,
            cursor: "pointer",
            textDecoration: "none",
            color: theme.palette.text.primary,
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              bgcolor: theme.palette.action.hover,
              color: theme.palette.primary.main,
            },
          }}
        >
          <Badge badgeContent={item.badge} color="error">
            <Box sx={{ color: "inherit" }}>{item.icon}</Box>
          </Badge>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              fontSize: "0.75rem",
              textAlign: "center",
              color: "inherit",
            }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default MobileBottomNav;
